import { Currency } from "../../common/constants/general-basic-data";
import { Price } from "../../common/models/string-data.model";
import { CarJobCategory, JobItemStatus, JobType } from "../constants/keep-basic-data";


 export class JobItem {

    jobItemId = 0;
    jobId = 0;

    jobTaskId = 0
    jobTaskCode = '';
    jobTaskTitle = '';
    jobTaskDetails = '';
    jobTaskCategory: CarJobCategory = CarJobCategory.AIR_CONDITIONING;

    jobItemCatalogId = 0;
    jobItemTemplateId = 0;

    type: JobType = JobType.ROUTINE;

    offerId = ""
    offerTitle = ""
    offerDescription = ""
    offerPosted = false
    offerClosed = false
    offerStartDate = ""
    offerEndDate = ""

    title = "";
    description = "";
    active = false;
    status: JobItemStatus = JobItemStatus.SCHEDULED;

    quantity = 0;
    unitAmount = 0;
    currency = Currency.XAF;

    unitPriceHistory: Price [] = [];

    created = "";
    lastUpdated = "";

    //jobTasks: CarJobTask [] = [];

    constructor(){
        this.unitPriceHistory = []
        //this.jobTasks = []
    }

 }
